var map = {
	"./CRM客户管理.png": 10142,
	"./FMS财务管理.png": 78795,
	"./HR人力管理.png": 71904,
	"./IoT智能设备互联.png": 6889,
	"./OMS订单管理.png": 6691,
	"./TMS运输管理.png": 61666,
	"./WMS仓储管理.png": 48641,
	"./云司机.png": 86024,
	"./企业OA.png": 37659,
	"./关于运脉.png": 33134,
	"./冷链运输平台.png": 32238,
	"./制造与商贸企业平台.png": 56563,
	"./危化运输平台.png": 20166,
	"./商砼运输平台.png": 89761,
	"./家具配送平台.png": 56647,
	"./应用中心.png": 50955,
	"./开发合作.png": 79798,
	"./数字物流技术平台.png": 82838,
	"./数字物流技术平台1.png": 55675,
	"./数智车务.png": 43532,
	"./渠道合作.png": 44015,
	"./物流承运商平台.png": 35676,
	"./物流承运商平台2.png": 7206,
	"./生态合作.png": 99370,
	"./运脉云OS.png": 63280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77642;